import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';

import {IconPipette, IconTrash} from './Icons';
import {_CMYK,_RGB,_RGBFix,CMYKtoRGB,fix255,fixHex,hexToRGB,RGBtoCMYK,rgbToHex} from './ColorTransformFuctions'

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class SpectrumPicker  extends Component {

  @observable trans = { };
  @observable currentColor = 'fff';
  @observable currentColorRGB = {
    r: 255,
    g: 100,
    b: 100
  }
  @observable currentColorCMYK = {
    c: 60,
    m: 100,
    y: 100,
    k: 0
  }


  colorPickerHandler = null;
  colorPickerInstanceHandler = null;

  @observable pickerMode = false;

  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    this.currentColor = this.props.currentColor ? this.props.currentColor : 'fff';
  }

  componentDidMount(){

    let scope = this;
    this.colorPickerInstanceHandler = $(this.colorPickerHandler).spectrum({
      clickoutFiresChange: true,
      preferredFormat: "hex",
      flat: true,
      showInput: false,
      move: function(color) {
        var c =  color.toHexString();

        scope.changeColor(c);
       // $(window).trigger('BackgroundColor-setBackgroundColor',c);
       // $(window).trigger('BackgroundColor-calculate',c);
      },
      change: function(color) {
        var c =  color.toHexString();

        scope.changeColor(c);
        //$(window).trigger('BackgroundColor-setBackgroundColor',c);

      },
      show : function(){

      }

    });

    this.choiceColor('#437e8b');
  }

  choiceColor(val){

    this.currentColor = (val).replace('#','');
    this.currentColorRGB = _RGBFix(hexToRGB(this.currentColor ));
    this.currentColorCMYK = RGBtoCMYK(this.currentColorRGB);
    this.colorPickerInstanceHandler.spectrum('set',this.currentColor);
  }

  changeHex(e){
    this.currentColor = e.target.value;
    this.currentColorRGB = _RGBFix(hexToRGB(this.currentColor ));
    this.currentColorCMYK = RGBtoCMYK(this.currentColorRGB);
    this.colorPickerInstanceHandler.spectrum('set',this.currentColor);
  }

  changeColor(val)
  {
    this.currentColorRGB = _RGBFix(hexToRGB(val));
    this.currentColorCMYK = RGBtoCMYK(this.currentColorRGB);
    this.currentColor = rgbToHex(this.currentColorRGB);
    this.colorPickerInstanceHandler.spectrum('set',this.currentColor);
  }

  changeRGB(e,rgb)
  {
    this.currentColorRGB[rgb] = fix255(e.target.value);
    this.currentColorRGB = _RGBFix(this.currentColorRGB);
    this.currentColorCMYK = RGBtoCMYK(this.currentColorRGB);
    this.currentColor = rgbToHex(this.currentColorRGB);
    this.colorPickerInstanceHandler.spectrum('set',this.currentColor);
  }

  render() {

    const t = this.t;
    const {colors,userColors} = this;

    return ( 
      <div className={"SpectrumPicker"}>
        <span ref={(input) => { this.colorPickerHandler = input; }}></span>

        <div className="SpectrumPicker-right" >
          <div className="SpectrumPicker-right-section">
            <span># <input  className="js-picker-hex" onChange={ (e)=> { this.changeHex(e) } }  value={this.currentColor} /></span>
            <div className="js-picker-rgb SpectrumPicker-rgb">
              <label>R</label><input onChange={ (e)=> { this.changeRGB(e,'r') } } value={this.currentColorRGB.r} />
              <label>G</label><input onChange={ (e)=> { this.changeRGB(e,'g') } } value={this.currentColorRGB.g} />
              <label>B</label><input onChange={ (e)=> { this.changeRGB(e,'b') } } value={this.currentColorRGB.b} />
            </div>
          </div>
          <div className="js-picker-cmyk SpectrumPicker-cmyk">
            <label>C</label><input disabled readOnly value={this.currentColorCMYK.c}/>
            <label>M</label><input disabled readOnly value={this.currentColorCMYK.m}/>
            <label>Y</label><input disabled readOnly value={this.currentColorCMYK.y}/>
            <label>K</label><input disabled readOnly value={this.currentColorCMYK.k}/>
          </div>
        </div>

        <div className="SpectrumPicker-footer ">
          <span className="SpectrumPicker-btn" onClick={ () => { this.enablePickerMode() } }><IconPipette/> {t('Picker')}</span>
          <span className="SpectrumPicker-btn" onClick={ () => { this.props.closePickArea() } }><IconTrash/>{t('Cancel')}</span>
          <span className="SpectrumPicker-add" onClick={ () => { this.props.addColor(this.currentColor) } } ><span style={{'backgroundColor':'#'+this.currentColor}}></span>{t('Add')}</span>
        </div>

      </div>
    );
  }



  getColorUnderXY(e){
    var scope = this;

    var canva = $('#creator-canvas')[0];
    var pos = $('#creator-canvas').offset();

    var x = e.pageX - pos.left - 37;
    var y = e.pageY - pos.top - 25 ;

    var coord = "x=" + x + ", y=" + y;

    var c = canva.getContext('2d');
    var p = c.getImageData(x, y, 1, 1).data;
    var rgb = {
      r: p[0],
      g: p[1],
      b: p[2]
    }

    var hex = "#" + ("000000" + rgbToHex(rgb)).slice(-6);

    return hex;

  }

  enablePickerMode() {
    var scope = this;

    scope.props.enablePickerMode();
    scope.pickerMode = true;

    $(window).trigger('ColorPicker-on');
    // $('#PickColorMobileInfo').addClass('active');

    $('body').addClass('picker-icon');


    if (isMobileDevice()) {

      $(document).on('click', function (e) {

        if (scope.pickerInCreatorArea(e)) {
          let color = scope.getColorUnderXY(e);

          if ( scope.pickerMode == true ){
            scope.choiceColor(color);
          }
          // scope.disablePickerMode();
        }
        else {

          scope.disablePickerMode();
        }
      })
    }
    else {
      $(document).on('click', 'body', function () {
        scope.disablePickerMode();
        scope.props.disablePickerMode();
      })


      $(document).on('click', '#PickColor', function (e) {

        e.preventDefault();
        e.stopPropagation();

        let color = scope.getColorUnderXY(e);

        if ( scope.pickerMode == true ){
          scope.choiceColor(color);
        }


        scope.disablePickerMode();
        scope.props.disablePickerMode();

      })


      $(document).on('mousemove', 'body', function (e) {

        if (scope.pickerInCreatorArea(e)) {
          $('#PickColor').addClass('active');
          $('#PickColor').css({
            left: e.pageX - 40,//+ 18,
            top: e.pageY - 40//- 19
          })

          scope.getColorUnderXY(e);

        }
        else {
          $('#PickColor').removeClass('active');
        }
      })
    }
  }

  disablePickerMode = function(){
    var scope = this;

    scope.props.disablePickerMode();
    scope.pickerMode = false;

    $(window).trigger('ColorPicker-off');

    $('#PickColor').removeClass('active');
    //$('#PickColorMobileInfo').removeClass('active');
    $('body').removeClass('picker-icon');

    $(document).off('click','#PickColor');
    $(document).off('click','body');
    $(document).off('mousemove','body');
    if ( isMobileDevice() )
    {
      $(document).off('click');
    }

  }

  pickerInCreatorArea(e){

    var x = e.pageX - 40;
    var y = e.pageY - 40;

    var container = $('#creator-area-container');
    var l = container.offset().left;
    var t = container.offset().top;
    var r = l + container.width();
    var b = t + container.height();

    if ( x < l ) return false;
    if ( x > r ) return false;
    if ( y < t ) return false;
    if ( y > b ) return false;

    return true;

  }

}


